import React from 'react';
import PropTypes from 'prop-types';

/**
 * Displays route statistics
 * @param {Object} props
 * @param {number} props.distanceNm - Distance in nautical miles
 * @param {number} props.durationMinutes - Duration in minutes
 * @param {number} props.avgSpeed - Average speed in knots
 * @param {number} props.maxSpeed - Maximum speed in knots
 */
const RouteInfoStats = ({ distanceNm, durationMinutes, avgSpeed, maxSpeed }) => {
  const formatDuration = (minutes) => {
    const hours = Math.floor(minutes / 60);
    const mins = Math.round(minutes % 60);
    return `${hours}h ${mins}m`;
  };

  return (
    <div className="route-info-section">
      <h3 className="section-title">Route Statistics</h3>
      <div className="stats-grid">
        <div className="stat-item">
          <span className="stat-label">Distance</span>
          <span className="stat-value">{distanceNm.toFixed(2)} NM</span>
        </div>
        <div className="stat-item">
          <span className="stat-label">Duration</span>
          <span className="stat-value">{formatDuration(durationMinutes)}</span>
        </div>
        <div className="stat-item">
          <span className="stat-label">Avg Speed</span>
          <span className="stat-value">{avgSpeed.toFixed(1)} kts</span>
        </div>
        <div className="stat-item">
          <span className="stat-label">Max Speed</span>
          <span className="stat-value">{maxSpeed.toFixed(1)} kts</span>
        </div>
      </div>
    </div>
  );
};

RouteInfoStats.propTypes = {
  distanceNm: PropTypes.number.isRequired,
  durationMinutes: PropTypes.number.isRequired,
  avgSpeed: PropTypes.number.isRequired,
  maxSpeed: PropTypes.number.isRequired,
};

export default RouteInfoStats;